import React from 'react'
import { Link } from 'react-router-dom'

import { colors } from '@lmc/common/constants'
// @ts-ignore
import { hexToRgbA } from '@lmc/common/utils'
import { ReactElement } from 'react'
import Badge from '../../../atoms/Badge'

export type EmarResidentMedicationCellProps = {
  controlledDrug?: boolean
  customName?: string
  id: string
  medication?: { name: string }
  PRN?: boolean
  resident?: string
}

export default function EmarResidentMedicationCell({
  PRN,
  controlledDrug,
  customName,
  id,
  medication,
  resident,
}: EmarResidentMedicationCellProps): ReactElement {
  return (
    <div>
      <div style={styles.container}>
        <Link to={`/residents/${resident}/emar/${id}/stock`}>
          <span style={styles.blackText}>
            {customName || (medication && medication.name)}
          </span>
        </Link>
        {controlledDrug && (
          <Badge
            color={hexToRgbA(colors.red, 0.2)}
            cornerType="square"
            style={styles.badge}
            text="CD"
            textColor={colors.red}
          />
        )}
        {PRN && (
          <Badge
            color={hexToRgbA(colors.blue, 0.2)}
            cornerType="square"
            style={styles.badge}
            text="PRN"
            textColor={colors.blue}
          />
        )}
      </div>
    </div>
  )
}

const styles = {
  container: {
    paddingTop: 3,
    display: 'flex',
  },
  badge: {
    fontSize: 12,
    height: 25,
    fontWeight: 'bold',
    marginLeft: 8,
    padding: '4px',
    borderRadius: 15,
  },
  blackText: {
    color: colors.black,
  },
}
